import React from 'react';
import Form from 'react-bootstrap/Form';
import { PACKING_LIST_TEXTO_ADICIONAL_MAX } from '../../vistas/packinglist/packingListSummaryText';

const TextoAdicionalPackingListField = ({
  value,
  onChange,
  className = 'mb-3',
  variant = 'bootstrap',
}) => {
  const length = String(value || '').length;
  const label = 'Texto adicional en Packing List';

  if (variant === 'input-group') {
    return (
      <div className={className}>
        <div className="input-group">
          <span className="input-group-text">{label}</span>
          <textarea
            className="form-control"
            rows={4}
            maxLength={PACKING_LIST_TEXTO_ADICIONAL_MAX}
            placeholder="Texto del bloque derecho del Summary (PDF/Excel)"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        <small className="text-muted">
          {length}/{PACKING_LIST_TEXTO_ADICIONAL_MAX} caracteres. Se precarga desde el cliente y se guarda en el
          packing list.
        </small>
      </div>
    );
  }

  return (
    <Form.Group className={className}>
      <Form.Label className="mb-1">{label}</Form.Label>
      <Form.Control
        as="textarea"
        rows={4}
        maxLength={PACKING_LIST_TEXTO_ADICIONAL_MAX}
        placeholder="Texto del bloque derecho del Summary (PDF/Excel)"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />
      <Form.Text className="text-muted">
        {length}/{PACKING_LIST_TEXTO_ADICIONAL_MAX} caracteres. Se precarga desde el cliente y se guarda en el packing
        list.
      </Form.Text>
    </Form.Group>
  );
};

export default TextoAdicionalPackingListField;
